// extracted by mini-css-extract-plugin
module.exports = {"MainHeader":"MainHeader_MainHeader__1IsB9","MainHeader__navBarIcon":"MainHeader_MainHeader__navBarIcon__3eeTv"};